import {AssetsRequestParams} from "../../../../infrastructure/models/params/assets-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../../core/app/consts";


export class NewsImageRequestParams extends AssetsRequestParams {
  constructor() {
    super();

    this.resourceName = `${this.resourceName}/BottomNavigationBar/NEWS`;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}
